module.exports = __webpack_public_path__ + "static/corporative-book-8b1f79318e9b59b77988b8b6feedb122.woff";